
module.exports = [
  'M16 0 A16 16 0 0 0 0 16 A16 16 0 0 0 16 32 A16 16 0 0 0 32 16 A16 16 0 0 0 16 0 M16 6 A10 10 0 0 1 20.675 7 L7 20.675 A10 10 0 0 1 6 16 A10 10 0 0 1 16 6 M26 16 A10 10 0 0 1 16 26 A10 10 0 0 1 11.325 25 L25 11.325 A10 10 0 0 1 26 16'
].join(' ')




/*****************
 ** WEBPACK FOOTER
 ** ./~/geomicons-open/src/paths/no.js
 ** module id = 221
 ** module chunks = 0
 **/